// English strings for the Phase 7c basic slot `headless` (APPS-03, AI-02/05/06) (D-013: English only).
// Spread into `en` as `en.headless`, so keys read `t("headless.…")`. Copy rules: DESIGN_SYSTEM §9.6.
export const headlessStrings = {
  keys: {
    title: "Headless storefront keys",
    create: "Create key",
    revoke: "Revoke",
    shownOnce: "Copy this key now. It is shown only once.",
    notIncluded: "The headless storefront API is not included in your plan.",
  },
  ai: {
    draftDescription: "Draft description",
    review: "Review the draft. Nothing is saved until you confirm it.",
    confirm: "Use this description",
    discard: "Discard",
    pendingActivation: "AI writing is not active yet.",
    quotaReached: "You have used all your AI credits for this month.",
  },
} as const;
